import { render } from "./OrganizationSet.vue?vue&type=template&id=5e786b8b&scoped=true&ts=true"
import script from "./OrganizationSet.vue?vue&type=script&lang=ts"
export * from "./OrganizationSet.vue?vue&type=script&lang=ts"

import "./OrganizationSet.vue?vue&type=style&index=0&id=5e786b8b&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e786b8b"]])

export default __exports__